module.exports = __webpack_public_path__ + "static/img/企业服务平台数据统计@4x.7ec26f87.png";